<template>
    <div class="inline-block">
        <AppButton @click="open = !open" element="button" type="button" desired-action>
            {{ $t('messages.import') }}
        </AppButton>
    </div>
    <SlideOver :show="open" @close="open = false" :title="$t('messages.import')">
        <div v-for="syllabus in importSyllabi" :key="syllabus.id">
            <AppButton element="InertiaLink" :href="syllabus.import_url" class="mt-3" type="button" desired-action>
                {{ syllabus.name }}
            </AppButton>
        </div>
    </SlideOver>
</template>

<script>
import SlideOver from '@/components/SlideOver.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    name: 'ImportSyllabusPanel',
    components: {
        SlideOver,
        AppButton,
    },
    data() {
        return {
            open: false,
        };
    },
    props: {
        importSyllabi: {
            type: Array,
            required: true,
        },
    },
    methods: {
        submit(url) {
            this.$inertia.post(
                url,
                {},
                {
                    onSuccess: () => {
                        this.open = false;
                    },
                },
            );
        },
    },
};
</script>
